// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "./polyfill";
// import cssVars from 'css-vars-ponyfill'
import Vue from "vue";
import BootstrapVue from "bootstrap-vue";

import App from "./App";
import router from "./router/index";
import store from "./vuex/store";

import i18n from "./i18n";
import axios from "axios";
import cookie from "js-cookie";

import Vuelidate from "vuelidate";
import { ClientTable, ServerTable } from "vue-tables-2";
import vSelect from "vue-select";
import moment from "moment";
import Vuesax from "vuesax";
import "material-icons/iconfont/material-icons.css";
import * as VueGoogleMaps from "vue2-google-maps";
import "vuesax/dist/vuesax.css"; //Vuesax styles
import VueLodash from "vue-lodash";
import VueApexCharts from "vue-apexcharts";
Vue.use(VueApexCharts);
const options = { name: "lodash" }; // customize the way you want to call it

Vue.use(VueLodash, options); // options is optional
Vue.use(Vuesax, {
  // options here
});
const Spinner = () => import("@/components/Spinner");
const StatusAlert = () => import("@/components/alerts/StatusAlert");
// todo
// cssVars()

Vue.use(BootstrapVue);
Vue.component("apexchart", VueApexCharts);
Vue.use(Vuelidate);
Vue.use(ClientTable);
Vue.use(ServerTable);
Vue.component("vSelect", vSelect);
Vue.component("Spinner", Spinner);
Vue.component("StatusAlert", StatusAlert);
import VueChangeCase from "vue-change-case";
Vue.use(VueChangeCase);

//VUE GOOGLE MAPS
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBb0F0NwZqQNeLSnu9ELPmzd8iDy6VHZ0s"
    // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then set installComponents to 'false'.
  //// If you want to automatically install all the components this property must be set to 'true':
  installComponents: true
});

//END VUE GOOGLE MAPS
// Global filters
Vue.filter("formatDate", function(value, lang) {
  if (lang == "es") {
    moment.locale("es-do");
  } else {
    moment.locale("en");
  }
  return moment(value).format("lll");
});
// Set token on reload
const token = cookie.get("ut");
if (token) {
  axios.defaults.headers.common["Authorization"] = token;
}
// Response handler
axios.interceptors.response.use(
  function(response) {
    if (store.getters["global/errorData"])
      store.commit("global/SET_ERROR", null);
    return response;
  },
  async function(error) {
    // console.log('Interceptor request: ', error.response.status)
    const errorData = {};
    // if (!error.response.status) throw error;
    // console.log(error);
    // throw error;
    switch (error.response.status) {
      case 401:
        console.log('401 Error');
        // errorData.status = error.response.status;
        errorData.status = 403;
        // errorData.route_to = -2;
        errorData.route_to = router.currentRoute.name;
        store.commit("global/SET_ERROR", errorData);
        await store.dispatch("session/AUTH_LOGOUT");
        // router.push({
        //   name: "Error"
        // });
        router.push({
          name: "Login"
        });
        break;
      case 403:
        console.log('403 Error');
        errorData.status = error.response.status;
        errorData.route_to = router.currentRoute.name;
        store.commit("global/SET_ERROR", errorData);
        await store.dispatch("session/AUTH_LOGOUT");
        router.push({
          name: "Login"
        });
        break;
      default:
        console.log('General Error: ', error);
        throw error;
      break;
    }
    return Promise.reject(error);
  }
);
const lang = localStorage.getItem("lang");
if (!lang) {
  localStorage.setItem("lang", "es");
  i18n.locale = "es";
} else {
  i18n.locale = lang;
}

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  template: "<App/>",
  store,
  i18n,

  components: {
    App
  }
});
